// extracted by mini-css-extract-plugin
export default {"form":"form___NmOjN","logo":"logo___gW7XW","header":"header___KzuLU","links":"links___IIQA7"};